import { render, staticRenderFns } from "./ExpressProblemTable.vue?vue&type=template&id=0cc92dbd&scoped=true"
import script from "./ExpressProblemTable.vue?vue&type=script&lang=js"
export * from "./ExpressProblemTable.vue?vue&type=script&lang=js"
import style0 from "./ExpressProblemTable.vue?vue&type=style&index=0&id=0cc92dbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc92dbd",
  null
  
)

export default component.exports